export default __webpack_public_path__ + "static/egg_alarm-ef2c2895cd2503c4e77b4f556f724f3a.mp3";